<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        <router-link to="/facilities">Facilities</router-link>
        <small>Facility Record</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Facilities</li>
        <li>Facility Record</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <!-- Left col -->
        <section class="col-lg-4 connectedSortable ui-sortable">
          <!-- Map box -->
          <div class="box box-solid">
            <div class="box-header ui-sortable-handle" style="cursor: move;">
              <i class="fa fa-map-marker"></i>
              <h3 class="box-title">
                Facility Record
              </h3>
              <span class="pull-right-container">
              <small class="label pull-right bg-red">NIVI</small>
            </span>
            </div>
            <div class="box-body">
              <h3 class="box-title">{{ facility.name }}</h3>
              <table class="table table-bordered table-striped">
                <tbody>
                <tr>
                  <td>Nivi ID</td>
                  <td>{{ facility._id }}</td>
                </tr>
                <tr>
                  <td>Active</td>
                  <td>{{ facility.active }}</td>
                </tr>
                <tr>
                  <td>Public</td>
                  <td>N/A</td>
                </tr>
                <tr>
                  <td>Type</td>
                  <td>{{ facility.type }}</td>
                </tr>
                <tr>
                  <td>Owner</td>
                  <td>{{ facility.owner }}</td>
                </tr>
                <tr>
                  <td>Size</td>
                  <td>{{ facility.size }}</td>
                </tr>
                <tr>
                  <td>Phone Number</td>
                  <td>
                    <ul>
                      <li v-for="phone in facility.phones">{{ phone }}</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>
                    <ul v-if="facility.emails">
                      <li v-for="email in facility.emails">{{ email }}</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Methods</td>
                  <td>
                    <ul>
                      <li v-for="methods in facility.methods">{{ methods }}</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>Youth Friendly</td>
                  <td>N/A</td>
                </tr>
                <tr>
                  <td>Network</td>
                  <td>N/A</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.box -->
        </section>
        <section class="col-lg-8 connectedSortable ui-sortable">

          <!-- Map box -->
          <div class="box box-solid">
            <div class="box-header ui-sortable-handle" style="cursor: move;">
              <i class="fa fa-map-marker"></i>

              <h3 class="box-title">
                Facility
              </h3>
            </div>
            <div class="alert alert-warning alert-dismissible" v-if="no_coordinates_message">
              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
              <h4><i class="icon fa fa-warning"></i> Alert!</h4>
              No Coordniates available for the facility
            </div>
            <div class="box-body" v-if="coordinates_available">
              <gmap-map
                :center="center"
                :zoom="10"
                style="width: auto; height: 500px"
              >
                <gmap-marker
                  :icon = "m.marker"
                  :key="index"
                  v-for="m in markers"
                  :position="m.position"
                  :clickable="true"
                  @click="center=m.position, m.opened=!m.opened"
                >
                  <gmap-info-window :opened="m.opened">{{ m.text }}</gmap-info-window>
                </gmap-marker>
              </gmap-map>
            </div>
            <!-- /.box-body-->
            <div class="box-footer">
              <table class="table table-bordered table-striped">
                <thead>
                <tr>
                  <td>County</td>
                  <td>SubCounty</td>
                  <td>Ward</td>
                  <td>Latitude</td>
                  <td>Longitude</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ facility.heirachy.county }}</td>
                  <td>{{ facility.heirachy.subcounty }}</td>
                  <td>{{ facility.ward }}</td>
                  <td>{{ markers[0].position.lat }}</td>
                  <td>{{ markers[0].position.lng }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- /.box -->
        </section>
        <!-- right col -->
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import * as VueGoogleMaps from 'vue2-google-maps'
  import Vue from 'vue'
  import {
    getNiviFacilitityById
  }
    from '../../../utils/stats'
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyB6PpVWtGqHvdWGbwlX_VkKvZgrHuhpHWE'
    }
  })
  export default {
    name: 'app-facilities',
    data () {
      return {
        nivi_status: {
          0: 'UNSURVEYED',
          1: 'INCOMPLETE',
          2: 'INACTIVE',
          3: 'ACTIVE'
        },
        coordinates_available: false,
        no_coordinates_message: false,
        center: {lat: 0.5679146, lng: 34.5645253},
        markers: [{
          position: {lat: '', lng: ''},
          text: '',
          opened: true
        }],
        mapPin: {
          path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
          fillColor: '#ffa500',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.5
        },
        mapSquare: {
          path: 'M22-48h-44v43h16l6 5 6-5h16z',
          fillColor: '#008000',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.5
        },
        mapSquareCircle: {
          path: 'M24-8c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32z',
          fillColor: '#e52c4f',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.5
        },
        mapTriangle: {
          path: 'M 100 100 L 300 100 L 200 300 z',
          fillColor: '#0000ff',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.1
        },
        facility: {}
      }
    },
    mounted () {
      getNiviFacilitityById(this.$route.params.facilityId).then((response) => {
        console.log(response.data)
        this.facility = response.data
        console.log(this.facility)
        if (this.facility.gps !== null) {
          this.center.lat = this.facility.gps.coordinates[1]
          this.center.lng = this.facility.gps.coordinates[0]
          this.markers[0].position.lat = this.facility.gps.coordinates[1]
          this.markers[0].position.lng = this.facility.gps.coordinates[0]
          this.markers[0].text = this.facility.name
          if (this.facility.status === this.nivi_status[0]) {
            this.markers[0].marker = this.mapPin
          } else if (this.facility.status === this.nivi_status[1]) {
            this.markers[0].marker = this.mapSquare
          } else if (this.facility.status === this.nivi_status[2]) {
            this.markers[0].marker = this.mapTriangle
          } else if (this.facility.status === this.nivi_status[3]) {
            this.markers[0].marker = this.mapSquareCircle
          }
          this.coordinates_available = true
        } else {
          this.coordinates_available = false
          this.no_coordinates_message = true
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// FacilityRecord.vue?46c24b6c